import { app } from "@/helpers/routes";
import { paths } from "../paths";
import SettingsPage from "@/pages/settings";

export const routes: Array<any> = [
  { path: paths.settings.index + "/:tab/:subtab", element: app(SettingsPage) },
];
